import anyBase from 'any-base'
import { v4 as uuid } from 'uuid'

const shortenHex = anyBase(anyBase.HEX, 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789')
const shortenUuid = (id: string) => shortenHex(id.replace(/-/g, ''))

export const generateId = () => shortenUuid(uuid())
